/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { atomToPromise } from 'customer-data-filters-ui/utils/atomToPromise';
import { getAssociatedRecordsUtils, getAssociationInfoFromPropertySuffix } from 'customer-data-filters-ui/utils/associatedRecordsUtils';
import { useEffect, useState } from 'react';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import styled from 'foundations-theming/utils';
import Raven from 'raven-js';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AssociationLabelWrapper = styled.span.withConfig({
  displayName: "DisplayValueAssociation__AssociationLabelWrapper",
  componentId: "xdq0hk-0"
})(({
  theme
}) => ({
  fontWeight: theme.typography['body-300'].fontWeight
}));
const DisplayValueAssociation = ({
  data,
  filterFamily,
  getFamilyValueResolver,
  operator
}) => {
  const {
    getAssociationDefinition,
    getCustomObjectReferenceResolver,
    getObjectDefinition,
    getObjectTypeIdFromPropertySuffix
  } = getAssociatedRecordsUtils(data, filterFamily);
  const [objectName, setObjectName] = useState('');
  const propertySuffix = operator.propertySuffix;
  const associatedObjectTypeId = getObjectTypeIdFromPropertySuffix(propertySuffix);
  const objectDefinition = associatedObjectTypeId ? getObjectDefinition(associatedObjectTypeId) : undefined;
  const resolver = getCustomObjectReferenceResolver(getFamilyValueResolver(operator), associatedObjectTypeId);
  const {
    associationId,
    associationCategory
  } = getAssociationInfoFromPropertySuffix(propertySuffix);
  const association = associatedObjectTypeId && propertySuffix ? getAssociationDefinition(associatedObjectTypeId, associationId, associationCategory) : undefined;
  const associationLabel = association && association.inverseLabel;
  useEffect(() => {
    if (resolver && typeof resolver.byId !== 'function') {
      Raven.captureException(new Error(`[Expected a reference resolver] resolver does not have 'byId' function; associatedObjectTypeId: ${associatedObjectTypeId}, operator.field: ${JSON.stringify(operator.field)}`));
    }
    if (resolver && resolver.byId && operator.value) {
      atomToPromise(resolver.byId(operator.value)).then(result => {
        setObjectName(result.label);
      });
    }
  }, [associatedObjectTypeId, operator.field, operator.value, resolver]);
  const singularForm = objectDefinition ? objectDefinition.singularForm : undefined;
  if (singularForm && objectName) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "customerDataFiltersUI.customerDataFilters.DisplayValueAssociation.label",
        options: {
          objectName,
          singularObjectType: singularForm
        }
      }), associationLabel && /*#__PURE__*/_jsx(AssociationLabelWrapper, {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "customerDataFiltersUI.customerDataFilters.DisplayValueAssociation.associationLabel",
          options: {
            associationLabel
          }
        })
      })]
    });
  }
  return /*#__PURE__*/_jsx("span", {
    children: operator.value
  });
};
export default DisplayValueAssociation;